import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import { PageLoader } from "@/components/common/loader";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { portalBusinesses, portalBusinessChild } from "@/features/portal/api";
import { portalHref } from "@/features/portal/portal-base";
import { BusinessCollection } from "./business-collection";
import { SUB_COLLECTIONS } from "./specs-data";

/** `/portal/financials/business/:businessId` — one business's sub-collections
 * (owners, accounts, assets, receivables, liabilities, …). */
export function BusinessDetail() {
  const { businessId } = useParams<{ businessId: string }>();
  const [name, setName] = useState<string | null>(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    if (!businessId) return;
    let active = true;
    portalBusinesses
      .list()
      .then((rows) => {
        if (!active) return;
        const match = rows.find((r) => r.id === businessId);
        if (match) setName(String(match.business_name ?? "Business"));
        else setMissing(true);
      })
      .catch(() => active && setMissing(true));
    return () => {
      active = false;
    };
  }, [businessId]);

  if (!businessId || missing)
    return (
      <Card className="p-8 text-center">
        <h3 className="font-semibold">Business not found</h3>
        <Button asChild variant="outline" className="mt-4">
          <Link to={portalHref("/financials/personal")}>Back to businesses</Link>
        </Button>
      </Card>
    );

  if (name === null) return <PageLoader />;

  return (
    <div className="grid gap-6">
      <div className="flex items-center gap-3">
        <Button asChild variant="ghost" size="sm">
          <Link to={portalHref("/financials/personal")}>
            <FiArrowLeft className="size-4" /> Businesses
          </Link>
        </Button>
        <h1 className="text-xl font-semibold">{name}</h1>
      </div>

      {SUB_COLLECTIONS.map((def) => (
        <BusinessCollection
          key={def.segment}
          api={portalBusinessChild(businessId, def.segment)}
          title={def.title}
          addLabel={def.addLabel}
          noun={def.noun}
          columns={def.columns}
          fields={def.fields}
          query={def.query}
        />
      ))}
    </div>
  );
}
